import React from 'react';

import { setCookie } from '@/app/[locale]/actions';
import { streamOpenAIResponse } from '@/app/[locale]/app-api/openai-chat/route';
import { updateToolLimitApi } from '@/app/[locale]/app-api/usertracking/user-information';

import { generatePrompt } from './promptTemplate';

export const handleGenerate = async (
  e: React.FormEvent,
  inputText: string,
  counter: number,
  tone: string,
  length: string,
  language: string,
  fingerprint: string,
  setLoading: (loading: boolean) => void,
  setIsStreaming: (isStreaming: boolean) => void,
  setStreamingResponse: (response: any) => void,
  setResponses: (responses: (prev: any) => any[]) => void,
  setCounter: (counter: (prev: any) => number) => void,
  setInputText: (text: string) => void
) => {
  e.preventDefault();

  if (inputText.trim() === '' || counter <= 0) {
    return;
  }

  setLoading(true); // Show spinner
  setIsStreaming(true); // Start streaming
  setStreamingResponse(''); // Reset streaming response

  const formData = {
    topic: inputText,
    tone,
    length,
    language
  };

  try {
    // Constructing the dynamic prompt based on formData
    const prompt = generatePrompt(formData);

    let fullResponse = ''; // Initialize variable to store the full response

    // Handle streaming
    await streamOpenAIResponse(prompt, 'Paraphraser', chunk => {
      fullResponse += chunk;
      setStreamingResponse((prev: string) => prev + chunk); // Append new chunk
    });

    // Save the final streaming response to the responses array
    setResponses(prev => {
      const updatedResponses = [fullResponse, ...prev];
      return updatedResponses;
    });

    // Reduce the counter and clear input fields
    setCounter(prev => prev - 1);
    // Call the updateToolLimit API to decrement the counter in the database
    await updateToolLimitApi(fingerprint, 'paraphraserLimit');

    // setInputText('');
  } catch (error) {
    console.error('Error generating response:', error);
  } finally {
    setLoading(false);
    setIsStreaming(false); // Stop streaming
    setStreamingResponse(''); // Clear the temporary streaming response
    await setCookie('ParaphraseTextlimiy', (counter - 1).toString());
  }
};

// responseHandlers.ts
